import { render, staticRenderFns } from "./NewLeadsItem.vue?vue&type=template&id=be5b01c6&"
import script from "./NewLeadsItem.vue?vue&type=script&lang=js&"
export * from "./NewLeadsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports